/** Energy — meter water usage /energy/charging-water (equipmentWater.vue) */
export default {
  equipmentWater: {
    filterStatPeriod: 'Period',
    phDateStart: 'Start',
    phDateEnd: 'End',
    filterWater: 'Water meter',
    phWater: 'Select meter',
    exportLoading: 'Exporting...',
    exportReport: 'Export',
    loadingText: 'Loading...',
    sectionTitle: 'Water usage',
    sectionTip: 'Select a meter to view details',
    colWaterId: 'Meter ID',
    colWaterName: 'Meter name',
    colSerial: 'Serial no.',
    colBindType: 'Binding type',
    colBindInfo: 'Binding',
    colOccurDate: 'Usage date',
    colWaterFee: 'Fee (CNY)',
    colWaterVolume: 'Volume (t)',
    colStartRead: 'Start reading',
    colEndRead: 'End reading',
    colTime: 'Time',
    colRead: 'Reading',
    emptyNoData: 'No data',
    emptyTip: 'Select a meter to load data',
    pickerLast7: 'Last 7 days',
    pickerLast15: 'Last 15 days',
    pickerLast30: 'Last 30 days',
    pickerThisMonth: 'This month',
    pickerLastMonth: 'Last month',
    msgWaterListFail: 'Failed to load meters',
    msgPickPeriod: 'Please select a date range',
    msgPickWater: 'Please select a meter',
    msgNoData: 'No records found',
    msgFetchFail: 'Failed to load data',
    msgDateMax31: 'Range cannot exceed 31 days',
    msgExportEmpty: 'Nothing to export',
    msgExportOk: 'Export completed',
    msgExportFail: 'Export failed',
    msgExportRetry: 'Try again',
    exportFilterLine: 'Period: {start} – {end} | Meter: {water}',
    bindType1: 'Dedicated',
    bindType2: 'Shared',
    bindType3: 'Formula',
    settleWay1: 'System',
    settleWay2: 'Manual',
    exportSheetName: 'Water usage',
    exportFilePrefix: 'water_usage',
    expColWaterId: 'Meter ID',
    expColWaterName: 'Meter name',
    expColSerial: 'Serial',
    expColBindType: 'Binding type',
    expColBindInfo: 'Binding',
    expColOccurDate: 'Date',
    expColSettleWay: 'Settlement',
    expColWaterFee: 'Fee (CNY)',
    expColWaterVolume: 'Volume (t)',
    expColStartRead: 'Start reading',
    expColEndRead: 'End reading',
    expColTime: 'Time',
    expColRead: 'Reading'
  }
}
